import React from 'react';
import _ from 'lodash';

import Autocomplete from 'components/base/Autocomplete';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import { SPACES } from 'common/constants/sizes';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';

const ServicesAutocomplete = ({
  multipleLimit,
  services = [],
  selectedService = [],
  onChange,
  width
}) => {
  const servicesDropdownOptions = _.chain(services)
    .orderBy('name')
    .map((service, index) => ({
      value: service.id,
      searchableValue: _.get(service, 'name'),
      displayValue: (
        <Flex items='center' key={_.get(service, 'id', index)}>
          <Text pl={SPACES.small} size='medium' ellipsisAfter>
            {_.get(service, 'name')}
          </Text>
        </Flex>
      )
    }))
    .value();
  return (
    <Autocomplete
      {...(width && { width })}
      placeholder='Select Services'
      options={servicesDropdownOptions}
      multiple={true}
      multipleLimit={multipleLimit}
      multiplePlaceholder={`${selectedService.length} Services`}
      selectedOptionValue={selectedService}
      onChange={services => {
        TrackingService.logEvent(TRACKING.EVENTS.FILTER, {
          page: TRACKING.PAGES.METRICS,
          filter_name: TRACKING.FILTER.SERVICE,
          service_name: services
        });
        onChange(services);
      }}
      dataCy='services-autocomplete'
      disableClearable={false}
    />
  );
};
export default ServicesAutocomplete;
